/* Native Bestow PDP interactions — vanilla port of the React PdpBestow hero
   behaviours (gallery, quantity, add-to-cart / buy-now, accordions, size guide,
   pincode checker, share, sticky bar). No dependencies. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function initRoot(root) {
    if (!root || root.__pdpInit) return;
    root.__pdpInit = true;
    var cartAdd = root.getAttribute("data-cart-add") || "/cart/add.js";

    /* ----------------------------- gallery ----------------------------- */
    var main = root.querySelector("[data-gallery-main]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var rail = root.querySelector("[data-gallery-rail]");
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        if (main && src) {
          main.style.opacity = "0";
          setTimeout(function () {
            main.src = src;
            main.style.opacity = "1";
          }, 200);
        }
        thumbs.forEach(function (b) {
          if (b === btn) {
            b.className = "shrink-0 w-[68px] h-[68px] overflow-hidden border border-tramBlue-500 ring-1 ring-tramBlue-500";
          } else {
            b.className = "shrink-0 w-[68px] h-[68px] overflow-hidden border border-tramBlue-400/30 hover:border-tramBlue-400/60";
          }
        });
      });
    });
    var up = root.querySelector("[data-gallery-up]");
    var down = root.querySelector("[data-gallery-down]");
    if (up && rail) up.addEventListener("click", function () { rail.scrollBy({ top: -200, behavior: "smooth" }); });
    if (down && rail) down.addEventListener("click", function () { rail.scrollBy({ top: 200, behavior: "smooth" }); });

    var mobile = root.querySelector("[data-gallery-mobile]");
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-dot]"));
    function setDot(i) {
      dots.forEach(function (d, j) {
        d.className = "block h-1.5 rounded-full transition-all " + (j === i ? "w-4 bg-tramBlue-500" : "w-1.5 bg-grey-85");
      });
    }
    if (mobile) {
      mobile.addEventListener("scroll", function () {
        var w = mobile.clientWidth;
        if (w) setDot(Math.round(mobile.scrollLeft / w));
      }, { passive: true });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        if (mobile) mobile.scrollTo({ left: i * mobile.clientWidth, behavior: "smooth" });
      });
    });

    /* ---------------------------- quantity ----------------------------- */
    var qtyVal = root.querySelector("[data-qty-val]");
    var qty = 1;
    function renderQty() { if (qtyVal) qtyVal.textContent = String(qty); }
    var dec = root.querySelector("[data-qty-dec]");
    var inc = root.querySelector("[data-qty-inc]");
    if (dec) dec.addEventListener("click", function () { qty = Math.max(1, qty - 1); renderQty(); });
    if (inc) inc.addEventListener("click", function () { qty = qty + 1; renderQty(); });

    /* -------------------------- add / buy now -------------------------- */
    function addToCart(variantId, quantity, then) {
      if (!variantId) return;
      fetch(cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () { window.location.href = then || "/cart"; })
        .catch(function () { /* noop */ });
    }
    Array.prototype.slice.call(root.querySelectorAll("[data-add-to-cart]")).forEach(function (b) {
      b.addEventListener("click", function () { addToCart(b.getAttribute("data-variant"), qty, "/cart"); });
    });
    var buyNow = root.querySelector("[data-buy-now]");
    if (buyNow) buyNow.addEventListener("click", function () { addToCart(buyNow.getAttribute("data-variant"), qty, "/checkout"); });

    /* ---------------------------- accordions --------------------------- */
    Array.prototype.slice.call(root.querySelectorAll("[data-acc-toggle]")).forEach(function (btn) {
      var wrap = btn.parentElement;
      var panel = wrap.querySelector("[data-acc-panel]");
      var chev = btn.querySelector("[data-acc-chevron]");
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.addEventListener("click", function () {
        open = !open;
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (chev) chev.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
        if (!panel) return;
        if (open) {
          panel.style.display = "";
          var h = panel.scrollHeight;
          panel.style.maxHeight = "0px";
          panel.style.transition = "max-height .3s ease";
          requestAnimationFrame(function () { panel.style.maxHeight = h + "px"; });
          setTimeout(function () { if (open) panel.style.maxHeight = "none"; }, 320);
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          requestAnimationFrame(function () { panel.style.maxHeight = "0px"; });
          setTimeout(function () { if (!open) panel.style.display = "none"; }, 320);
        }
      });
    });

    /* --------------------------- size guide ---------------------------- */
    var modal = root.querySelector("[data-sizeguide-modal]");
    var openBtn = root.querySelector("[data-sizeguide-open]");
    function openModal() {
      if (!modal) return;
      modal.style.display = "flex";
      document.body.style.overflow = "hidden";
    }
    function closeModal() {
      if (!modal) return;
      modal.style.display = "none";
      document.body.style.overflow = "";
    }
    if (openBtn) openBtn.addEventListener("click", openModal);
    if (modal) {
      Array.prototype.slice.call(modal.querySelectorAll("[data-sizeguide-close]")).forEach(function (c) {
        c.addEventListener("click", closeModal);
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });
      var capCell = modal.querySelector("[data-sg-capacity]");
      var servesCell = modal.querySelector("[data-sg-serves]");
      var sizeBtns = Array.prototype.slice.call(modal.querySelectorAll("[data-sg-size]"));
      sizeBtns.forEach(function (sb) {
        sb.addEventListener("click", function () {
          var cap = sb.getAttribute("data-cap");
          var srv = sb.getAttribute("data-serves");
          if (capCell && cap) capCell.textContent = cap;
          if (servesCell && srv) servesCell.textContent = srv;
          sizeBtns.forEach(function (b) {
            var sel = b === sb;
            b.className = "px-3 py-1.5 text-sm border transition-colors " + (sel ? "bg-tramBlue-500 text-white border-tramBlue-500" : "bg-white text-grey-700 border-grey-50 hover:border-tramBlue-500");
          });
        });
      });
    }

    /* ----------------------------- pincode ----------------------------- */
    var pinWrap = root.querySelector("[data-pincode]");
    if (pinWrap) {
      var pinInput = pinWrap.querySelector("[data-pincode-input]");
      var pinBtn = pinWrap.querySelector("[data-pincode-check]");
      var pinMsg = pinWrap.querySelector("[data-pincode-msg]");
      function showMsg(text, cls) {
        if (!pinMsg) return;
        pinMsg.textContent = text;
        pinMsg.className = "text-sm " + cls;
        pinMsg.style.display = "";
      }
      function clearMsg() { if (pinMsg) pinMsg.style.display = "none"; }
      if (pinInput) pinInput.addEventListener("input", function () {
        pinInput.value = pinInput.value.replace(/\D/g, "").slice(0, 6);
        clearMsg();
      });
      function check() {
        var code = (pinInput ? pinInput.value : "").replace(/\D/g, "").slice(0, 6);
        if (code.length !== 6) { showMsg("Please enter a valid 6-digit pincode.", "text-burgundy-500"); return; }
        if (pinBtn) { pinBtn.disabled = true; pinBtn.textContent = "Checking…"; }
        var csvUrl = pinWrap.getAttribute("data-pincode-csv") || "https://cdn.shopify.com/s/files/1/0701/6474/2368/files/pincode-service-Shopify-11Apr.csv";
        fetch(csvUrl)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var rows = text.split(/\r?\n/).slice(1);
            var ok = false;
            for (var i = 0; i < rows.length; i++) {
              var parts = rows[i].split(",");
              var p = (parts[0] || "").trim();
              var svc = (parts[1] || "").trim().toLowerCase();
              if (/^\d{6}$/.test(p) && svc === "available" && p === code) { ok = true; break; }
            }
            if (ok) showMsg("Delivery available — estimated 3–5 business days.", "text-green-600");
            else showMsg("Sorry, delivery isn't available for this pincode.", "text-burgundy-500");
          })
          .catch(function () { showMsg("Couldn't check right now. Please try again.", "text-burgundy-500"); })
          .then(function () { if (pinBtn) { pinBtn.disabled = false; pinBtn.textContent = "Check"; } });
      }
      if (pinBtn) pinBtn.addEventListener("click", check);
      if (pinInput) pinInput.addEventListener("keydown", function (e) { if (e.key === "Enter") check(); });
    }

    /* ------------------------------ share ------------------------------ */
    var shareBtn = root.querySelector("[data-share]");
    var shareToast = root.querySelector("[data-share-toast]");
    if (shareBtn) shareBtn.addEventListener("click", function () {
      var url = window.location.href;
      if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (shareToast) { shareToast.style.display = ""; setTimeout(function () { shareToast.style.display = "none"; }, 1600); }
        }).catch(function () {});
      }
    });

    /* --------------------------- sticky bar ---------------------------- */
    var sticky = root.querySelector("[data-sticky-bar]");
    if (sticky) {
      var stickyShown = false;
      window.addEventListener("scroll", function () {
        var show = window.scrollY > 600;
        if (show === stickyShown) return;
        stickyShown = show;
        // Remove the inline display:none so the `hidden sm:flex` classes govern
        // visibility (none < sm, flex >= sm), matching the React behaviour.
        sticky.style.display = show ? "" : "none";
      }, { passive: true });
    }
  }

  /* ===================== story sections ===================== */

  var PILL_ON = "shrink-0 relative px-3 py-1 rounded-full border text-sm font-body transition-colors duration-300 bg-rose-900 border-rose-900 text-cotton-50";
  var PILL_OFF = "shrink-0 relative px-3 py-1 rounded-full border text-sm font-body transition-colors duration-300 border-rose-900 text-rose-900 hover:bg-rose-900/5";

  function initMaterial(sec) {
    if (sec.__init) return; sec.__init = true;
    var pills = Array.prototype.slice.call(sec.querySelectorAll("[data-material-pill]"));
    if (pills.length < 2) return;
    var titleEl = sec.querySelector("[data-material-title]");
    var bodyEl = sec.querySelector("[data-material-body]");
    var imgEl = sec.querySelector("[data-material-img]");
    var textWrap = sec.querySelector("[data-material-text]");
    var active = 0, paused = false, timer = null;
    function render(i) {
      var p = pills[i]; if (!p) return;
      if (textWrap) textWrap.style.opacity = "0";
      if (imgEl) imgEl.style.opacity = "0";
      setTimeout(function () {
        if (titleEl) titleEl.textContent = p.getAttribute("data-title");
        if (bodyEl) bodyEl.textContent = p.getAttribute("data-body");
        if (imgEl) { imgEl.src = p.getAttribute("data-img"); imgEl.style.opacity = "1"; }
        if (textWrap) textWrap.style.opacity = "1";
      }, 200);
      pills.forEach(function (b, j) { b.className = j === i ? PILL_ON : PILL_OFF; });
      active = i;
    }
    pills.forEach(function (p, i) {
      p.addEventListener("click", function () { render(i); paused = true; setTimeout(function () { paused = false; }, 8000); });
    });
    function start() { if (timer) return; timer = setInterval(function () { if (!paused) render((active + 1) % pills.length); }, 4000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    try {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) start(); else stop(); }, { threshold: 0.3 });
      io.observe(sec);
    } catch (e) { start(); }
  }

  function initMarquee(sec) {
    if (sec.__init) return; sec.__init = true;
    var track = sec.querySelector("[data-marquee-track]");
    if (!track) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var x = 0, paused = false, last = null, cycle = 0;
    function measure() { cycle = track.scrollWidth / 2; }
    measure(); window.addEventListener("resize", measure);
    sec.addEventListener("mouseenter", function () { paused = true; });
    sec.addEventListener("mouseleave", function () { paused = false; });
    sec.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    sec.addEventListener("touchend", function () { paused = false; });
    function frame(t) {
      if (last == null) last = t;
      var dt = t - last; last = t;
      if (!paused && cycle) {
        x -= (40 * dt) / 1000;
        if (x <= -cycle) x += cycle;
        track.style.transform = "translateX(" + x + "px)";
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function setFaq(btn, open) {
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    btn.className = "group w-full flex items-start justify-between gap-6 lg:gap-8 text-left p-4 lg:p-6 transition-colors duration-300 " + (open ? "bg-sky-50" : "bg-transparent hover:bg-sky-50/40");
    var ans = btn.querySelector("[data-faq-answer]");
    if (ans) ans.style.display = open ? "" : "none";
    var ic = btn.querySelector("[data-faq-icon]");
    if (ic) { ic.style.transform = open ? "rotate(45deg)" : "rotate(0deg)"; ic.style.color = open ? "#A32421" : "#0000B7"; }
  }
  function initFaq(sec) {
    if (sec.__init) return; sec.__init = true;
    var toggles = Array.prototype.slice.call(sec.querySelectorAll("[data-faq-toggle]"));
    toggles.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        toggles.forEach(function (b) { setFaq(b, false); });
        if (!isOpen) setFaq(btn, true);
      });
    });
  }

  function initNewsletter(btn) {
    if (btn.__init) return; btn.__init = true;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var id = btn.getAttribute("data-popup-id");
      try {
        if (!id) { var m = document.cookie.match(/ecomsend[_-]?popups?[_-]?(\d+)/i); id = m ? m[1] : ""; }
        var token = "Ecomsend_popups_open_" + id;
        if (window.EcomSendApps && window.EcomSendApps.actions && window.EcomSendApps.actions.initHashPopup) {
          window.EcomSendApps.actions.initHashPopup(token);
        } else {
          location.hash = "#" + token;
          window.dispatchEvent(new HashChangeEvent("hashchange"));
        }
      } catch (err) { /* noop */ }
    });
  }

  /* --------------------------- reviews (Opinew) --------------------------- */
  var STAR_POLY = "12,2 15,9 22,9 17,14 18.5,21 12,17.5 5.5,21 7,14 2,9 9,9";
  var _starUid = 0;
  function starsHtml(rating, size) {
    size = size || 16;
    var full = Math.floor(rating), half = rating - full >= 0.5, out = '<div class="flex items-center gap-0.5">';
    for (var i = 0; i < 5; i++) {
      if (i < full) out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="#0000B7"><polygon points="' + STAR_POLY + '"/></svg>';
      else if (i === full && half) { var id = "jsstar" + (_starUid++); out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24"><defs><linearGradient id="' + id + '"><stop offset="50%" stop-color="#0000B7"/><stop offset="50%" stop-color="#E5E5E5"/></linearGradient></defs><polygon fill="url(#' + id + ')" points="' + STAR_POLY + '"/></svg>'; }
      else out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="#E5E5E5"><polygon points="' + STAR_POLY + '"/></svg>';
    }
    return out + "</div>";
  }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
  function mapReview(r) {
    var m = String(r.created_ts || "").match(/(\d{4})-(\d{2})-(\d{2})/);
    return { name: r.user_name || "Anonymous", date: m ? m[3] + "/" + m[2] + "/" + m[1].slice(2) : "", title: r.title || "", body: r.body || "", stars: Number(r.star_rating) || 0, verified: !!r.verified_review };
  }
  function initReviews(sec) {
    if (sec.__init) return; sec.__init = true;
    var rawEl = sec.querySelector("[data-reviews-raw]"), mount = sec.querySelector("[data-reviews-mount]");
    if (!rawEl || !mount) return;
    var data;
    try { var ta = document.createElement("textarea"); ta.innerHTML = rawEl.textContent; data = JSON.parse(ta.value); } catch (e) { sec.style.display = "none"; return; }
    var p = (data && data.product) || {};
    var useRating = Number(p.rating_number) > 0;
    var count = (useRating ? Number(p.rating_number) : Number(p.review_number)) || 0;
    var average = Number(useRating ? p.average_rating : p.average_stars) || 0;
    var dist = (useRating ? p.rating_star_distribution : p.star_distribution) || {};
    var distribution = [5, 4, 3, 2, 1].map(function (star) { var c = Number(dist[String(star)]) || 0; return { star: star, count: c, percent: count ? Math.round((c / count) * 100) : 0 }; });
    var rv = data.reviews || {};
    var src = (rv.recent && rv.recent.length ? rv.recent : (rv.content && rv.content.length ? rv.content : (p.review_ugc || []))) || [];
    var written = src.map(mapReview);
    var rd = p.rating_star_distribution || {}, wd = p.star_distribution || {}, extras = [];
    [5, 4, 3, 2, 1].forEach(function (star) { var diff = (Number(rd[star]) || 0) - (Number(wd[star]) || 0); for (var k = 0; k < diff; k++) extras.push({ name: "Anonymous", date: "", title: "", body: "", stars: star, verified: false }); });
    var reviews = written.concat(extras);
    if (count === 0 && reviews.length === 0) { sec.style.display = "none"; return; }
    var hist = distribution.map(function (row) {
      return '<div class="flex items-center gap-2"><span class="text-sm text-grey-400 w-3">' + row.star + '</span><svg width="14" height="14" viewBox="0 0 24 24" fill="#0000B7"><polygon points="' + STAR_POLY + '"/></svg><div class="relative h-1 w-[100px] bg-sky-200 rounded"><div class="absolute inset-y-0 left-0 bg-tramBlue-500 rounded" style="width:' + row.percent + '%"></div></div><span class="text-sm text-grey-400 w-6">' + row.count + "</span></div>";
    }).join("");
    var summary = '<div class="mt-8 max-w-[1234px] mx-auto flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 lg:gap-12 px-2 lg:px-[60px]">'
      + '<div class="flex items-end gap-3"><span class="font-display text-2xl font-medium text-[#46430e] leading-none">' + average.toFixed(1) + '</span><div class="flex flex-col gap-1">' + starsHtml(average, 16) + '<span class="text-sm text-grey-400">' + count.toLocaleString("en-IN") + ' reviews</span></div></div>'
      + '<div class="hidden lg:block h-[116px] w-px bg-grey-50"></div>'
      + '<div class="flex flex-col gap-1 w-full lg:w-auto">' + hist + '</div>'
      + '<div class="hidden lg:block h-[116px] w-px bg-grey-50"></div>'
      + '<button class="flex items-center gap-3 px-6 lg:px-8 py-3 border border-grey-50 text-sm text-grey-500">Most Recent<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg></button>'
      + "</div>";
    var visible = 2;
    var items = reviews.map(function (r, i) {
      var itemHidden = i >= visible, hairHidden = i + 1 >= visible;
      var verified = r.verified ? '<div class="bg-green-50 inline-flex items-center gap-2 px-2 py-0.5 rounded-full self-start"><svg width="12" height="12" viewBox="0 0 24 24" fill="#727F20"><circle cx="12" cy="12" r="11" fill="#727F20"/><polyline points="7 12 10.5 16 17 9" stroke="white" stroke-width="2" fill="none"/></svg><span class="text-xs text-green-600 leading-tight">Verified Buyer</span></div>' : "";
      var art = '<div' + (itemHidden ? ' data-review-hidden style="display:none"' : "") + '><article class="flex flex-col lg:flex-row gap-4 lg:gap-10 items-start p-4 lg:p-6">'
        + '<div class="flex flex-col gap-2 min-w-[180px]"><p class="text-base text-grey-500">' + esc(r.name) + '</p>' + verified + '</div>'
        + '<div class="flex-1 flex flex-col gap-3 py-3 min-w-0"><div class="flex items-center justify-between gap-3">' + starsHtml(r.stars, 16) + (r.date ? '<span class="text-sm text-grey-400">' + esc(r.date) + '</span>' : "") + '</div>'
        + (r.title ? '<p class="text-base text-grey-500 leading-6 max-w-[600px]">' + esc(r.title) + '</p>' : "")
        + (r.body ? '<p class="text-sm text-grey-400 leading-5 max-w-[600px]">' + esc(r.body) + '</p>' : "")
        + '</div></article></div>';
      var hair = i < reviews.length - 1 ? '<div class="h-px w-full bg-grey-50"' + (hairHidden ? ' data-review-hidden style="display:none"' : "") + "></div>" : "";
      return art + hair;
    }).join("");
    var loadMore = reviews.length > visible ? '<div class="mt-8 flex justify-center"><button data-reviews-more class="bg-cotton-500 border border-tramBlue-400 text-tramBlue-500 px-8 py-3 text-base hover:bg-cotton-100 transition-colors">Load More</button></div>' : "";
    mount.innerHTML = summary + '<div class="mt-10 max-w-[1234px] mx-auto flex flex-col">' + items + "</div>" + loadMore;
    var moreBtn = mount.querySelector("[data-reviews-more]");
    if (moreBtn) moreBtn.addEventListener("click", function () { Array.prototype.slice.call(mount.querySelectorAll("[data-review-hidden]")).forEach(function (el) { el.style.display = ""; }); moreBtn.style.display = "none"; });
  }

  /* --------------------------- UGC testimonials --------------------------- */
  function initUgc(sec) {
    if (sec.__init) return; sec.__init = true;
    var rail = sec.querySelector("[data-ugc-rail]");
    if (!rail) return;
    function metrics() {
      var first = rail.querySelector("[data-card]");
      if (!first) return { cw: 0, gap: 0 };
      var cs = getComputedStyle(rail);
      return { cw: first.getBoundingClientRect().width, gap: parseFloat(cs.columnGap || cs.gap || "0") || 0 };
    }
    function scrollByCards(n) { var m = metrics(); rail.scrollBy({ left: (m.cw + m.gap) * n, behavior: "smooth" }); }
    Array.prototype.slice.call(sec.querySelectorAll("[data-ugc-prev]")).forEach(function (b) { b.addEventListener("click", function () { scrollByCards(-2); }); });
    Array.prototype.slice.call(sec.querySelectorAll("[data-ugc-next]")).forEach(function (b) { b.addEventListener("click", function () { scrollByCards(2); }); });
    var dots = Array.prototype.slice.call(sec.querySelectorAll("[data-ugc-dot]"));
    rail.addEventListener("scroll", function () {
      var m = metrics(), pw = (m.cw + m.gap) * 2; if (pw <= 0) return;
      var ap = Math.round(rail.scrollLeft / pw);
      dots.forEach(function (d, j) { d.className = "block h-1.5 rounded-full transition-all " + (j === ap ? "w-3 bg-tramBlue-500" : "w-1.5 bg-grey-50"); });
    }, { passive: true });
    Array.prototype.slice.call(sec.querySelectorAll("[data-ugc-video]")).forEach(function (v) {
      try { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: 0.4 }); io.observe(v); } catch (e) {}
      var btn = v.parentElement.querySelector("[data-ugc-mute]");
      if (btn) btn.addEventListener("click", function () { v.muted = !v.muted; v.play().catch(function () {}); });
    });
  }

  ready(function () {
    var q = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
    q("[data-pdp-native]").forEach(initRoot);
    q("[data-material]").forEach(initMaterial);
    q("[data-marquee]").forEach(initMarquee);
    q("[data-faq]").forEach(initFaq);
    q("[data-newsletter-cta]").forEach(initNewsletter);
    q("[data-reviews]").forEach(initReviews);
    q("[data-ugc]").forEach(initUgc);
  });
})();
